export const DESTINO_LABEL = "Destino do valor projetado";
export const DESTINO_OBRIGATORIO = "Escolha o destino do valor projetado.";
